import type { PRAIPrompt } from '../../types/salesforce'

export interface AIGenerationDialogProps {
  open: boolean
  onClose: () => void
  onGenerate: (additionalPrompt: string, targetFields: string[]) => void
  prompt: PRAIPrompt
  loading?: boolean
}

export interface FieldSection {
  title: string
  fields: FieldOption[]
}

export interface FieldOption {
  name: string
  label: string
}

// フィールドラベル辞書（実際の入力フィールドに表示されるラベルと完全一致）
export const FIELD_LABELS: Record<string, string> = {
  // PRSheet フィールド
  Catchphrase__c: 'キャッチコピー',
  Jobs__c: 'Jobs',
  PRSummary__c: 'PRサマリー',

  // Experience フィールド
  'Experience.Year__c': '年度',
  'Experience.Title__c': 'タイトル',
  'Experience.Overview__c': '概要',
  'Experience.Results__c': '成果',

  // PortfolioItem フィールド
  'PortfolioItem.Title__c': 'タイトル',
  'PortfolioItem.URL__c': 'URL',
  'PortfolioItem.Overview__c': '概要',
  'PortfolioItem.Role__c': 'あなたの役割',

  // HighlightEpisode フィールド
  'HighlightEpisode.Title__c': 'エピソードタイトル',
  'HighlightEpisode.Summary__c': 'サマリー',
  'HighlightEpisode.Goal__c': '目的',
  'HighlightEpisode.Challenges__c': '直面した課題',
  'HighlightEpisode.Team__c': 'メンバー構成',
  'HighlightEpisode.Role__c': '役割と貢献',
  'HighlightEpisode.Actions__c': '具体的な取り組み',
  'HighlightEpisode.Results__c': '成果',

  // Education フィールド
  'Education.Year__c': '年',
  'Education.SchoolName__c': '学校名',
  'Education.Department__c': '学部',
  'Education.Status__c': 'ステータス',

  // Link フィールド
  'Link.LinkName__c': '名前',
  'Link.URL__c': 'URL',
}

export const FIELD_SECTIONS: FieldSection[] = [
  {
    title: 'About Me',
    fields: [
      { name: 'Catchphrase__c', label: FIELD_LABELS['Catchphrase__c'] },
      { name: 'Jobs__c', label: FIELD_LABELS['Jobs__c'] },
      { name: 'PRSummary__c', label: FIELD_LABELS['PRSummary__c'] },
    ],
  },
  {
    title: 'これまでの主な取り組み（新規作成）',
    fields: [
      { name: 'Experience.Title__c', label: FIELD_LABELS['Experience.Title__c'] },
      { name: 'Experience.Year__c', label: FIELD_LABELS['Experience.Year__c'] },
      { name: 'Experience.Overview__c', label: FIELD_LABELS['Experience.Overview__c'] },
      { name: 'Experience.Results__c', label: FIELD_LABELS['Experience.Results__c'] },
    ],
  },
  {
    title: '制作ポートフォリオ（新規作成）',
    fields: [
      { name: 'PortfolioItem.Title__c', label: FIELD_LABELS['PortfolioItem.Title__c'] },
      { name: 'PortfolioItem.URL__c', label: FIELD_LABELS['PortfolioItem.URL__c'] },
      { name: 'PortfolioItem.Overview__c', label: FIELD_LABELS['PortfolioItem.Overview__c'] },
      { name: 'PortfolioItem.Role__c', label: FIELD_LABELS['PortfolioItem.Role__c'] },
    ],
  },
  {
    title: '注力エピソード（新規作成）',
    fields: [
      { name: 'HighlightEpisode.Title__c', label: FIELD_LABELS['HighlightEpisode.Title__c'] },
      { name: 'HighlightEpisode.Summary__c', label: FIELD_LABELS['HighlightEpisode.Summary__c'] },
      { name: 'HighlightEpisode.Goal__c', label: FIELD_LABELS['HighlightEpisode.Goal__c'] },
      { name: 'HighlightEpisode.Challenges__c', label: FIELD_LABELS['HighlightEpisode.Challenges__c'] },
      { name: 'HighlightEpisode.Team__c', label: FIELD_LABELS['HighlightEpisode.Team__c'] },
      { name: 'HighlightEpisode.Role__c', label: FIELD_LABELS['HighlightEpisode.Role__c'] },
      { name: 'HighlightEpisode.Actions__c', label: FIELD_LABELS['HighlightEpisode.Actions__c'] },
      { name: 'HighlightEpisode.Results__c', label: FIELD_LABELS['HighlightEpisode.Results__c'] },
    ],
  },
  {
    title: '学歴（新規作成）',
    fields: [
      { name: 'Education.Year__c', label: FIELD_LABELS['Education.Year__c'] },
      { name: 'Education.SchoolName__c', label: FIELD_LABELS['Education.SchoolName__c'] },
      { name: 'Education.Department__c', label: FIELD_LABELS['Education.Department__c'] },
      { name: 'Education.Status__c', label: FIELD_LABELS['Education.Status__c'] },
    ],
  },
  {
    title: '外部リンク（新規作成）',
    fields: [
      { name: 'Link.LinkName__c', label: FIELD_LABELS['Link.LinkName__c'] },
      { name: 'Link.URL__c', label: FIELD_LABELS['Link.URL__c'] },
    ],
  },
]
